import { RoomCard } from "../components";
import { Helmet } from 'react-helmet-async'
import { useTranslation } from "react-i18next";

export const Accommodation = () => {
  const { t } = useTranslation("acco");

  const roomDetails = [
    { source: "/assets/comfortPlus/img2.webp", roomType: "Comfort", description: t("accommodationPage.rooms.comfortDescription"), title: "Comfort room" },
    { source: "/assets/comfortPlus/img4.webp", roomType: "Comfort Plus", description: t("accommodationPage.rooms.comfortPlusDescription"), title: "Comfort plus room" },
    { source: "/assets/comfortPlus/img3.webp", roomType: "Duplex", description: t("accommodationPage.rooms.duplexDescription"), title: "Duplex room" },
  ];

  return (
    <main>

      <Helmet>
        <title> ACCOMMODATION | Regina Pacis </title>
        <meta name="keywords" content="studentenhuisvesting, studentenkamers, studentenwoning, kamers te huur Leuven, studentenhuis Leuven, studio huren Leuven, studentenkamer Leuven, studentenappartement, studentenresidentie, studentenflat Leuven, kot te huur, kamers voor studenten, goedkope studentenkamers, studentenkoten Leuven, huur studentenkamer, Dirk Boutslaan 64, 3000 Leuven, Belgium, BELGIUM, studentenverblijf, studentenkamer vinden, koten Leuven, studentenstudios, studentenwoonruimte, student housing, student accommodation, student rooms, rooms for rent Leuven, student apartments, student studio, student residence, student flat Leuven, student rental, student housing Leuven, cheap student rooms, student lodgings, student dorms, student living, student flats, student stay, find student room, Leuven student housing, student studios, student living space" />
        <meta name="description" content="Stylish rooms with modern furnishings, offering comfort and convenience. Choose from cozy Comfort Rooms, spacious Comfort Plus, or luxurious Duplex Suites for groups or families." />
        <link rel="canonical" href="https://www.residentiereginapacis.be/accommodation" />
      </Helmet>

      <div className="flex justify-center p-2 max-sm:text-lg sm:text-xl flex-col items-center gap-4">
        <p className="text-center">
          {t("accommodationPage.title.prefix")} <span className="text-textColor font-bold">{t("accommodationPage.title.highlight")}</span>{t("accommodationPage.title.post")}
        </p>
        <p className="text-center">
          {t("accommodationPage.description.details")} <strong>{t("accommodationPage.description.typeOfRooms")}</strong>:
        </p>
        <p className="underline text-clickable hover:">
          <a href="https://my.matterport.com/show/?m=ncTjh1PNFtt" target="_blank" rel="noreferrer">{t("accommodationPage.viewRoomIn3D")}</a>
        </p>
      </div>

      {
        <RoomCard roomDetails={roomDetails} />
      }

    </main>
  );
};
